import {
  useMutation,
  UseMutationResult,
  useQuery,
} from "@tanstack/react-query";
import { user } from "../products/user";
import {
  AllUsersInterface,
  DeleteParams,
  UserBYIdInterFace,
} from "../types/types";

export function useGetAllRegisterUsers(option?: any) {
  const { data, isLoading, error, status, isSuccess, refetch } =
    useQuery<AllUsersInterface>({
      queryKey: ["getAllRegisterUsers"],
      queryFn: () => user.GetAllUsers(option),
    });

  return {
    registerUser: data,
    registerUserLoading: isLoading,
    error,
    status,
    isSuccess,
    registerUserRefetch: refetch,
  };
}

export function useGetSingleUser(id: number) {
  const { data, isLoading, error, status, isSuccess, refetch } =
    useQuery<UserBYIdInterFace>({
      queryKey: ["getSingleUsers", id],
      queryFn: () => user.GetSingleUser(id),
      enabled: !!id,
    });

  return {
    UserDetail: data,
    UserLoading: isLoading,
    error,
    status,
    isSuccess,
    UserRefetch: refetch,
  };
}
export function useDeleteUser(): UseMutationResult<
  any,
  unknown,
  DeleteParams,
  unknown
> {
  return useMutation({
    mutationFn: (body: DeleteParams) => user.deleteUser(body.id),
  });
}

export function useResetPassword():any{
  return useMutation({
    mutationFn: (body: any) => user.ResetPassword(body),
  });
}
